export default __webpack_public_path__ + "static/media/Logo-Realie.db2e93f4.jpg";